module.exports = "/_next/static/images/OrchestrateAndOptimize@2x-dfb83cd7c7dc5e7cfd69881d55827f3d.png";